<template>
  <div
    class="uk-grid-small"
    uk-grid
  >
    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'grey'"
        :data="String(claimCounts.received || 0)"
        :subtitle="'Data'"
        :status="'Form Diterima DPLK'"
        :route-name="'Claim'"
        :query-params="{ status: 'received' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'grey'"
        :data="String(claimCounts.checking || 0)"
        :subtitle="'Data'"
        :status="'Pemeriksaan Dokumen'"
        :route-name="'Claim'"
        :query-params="{ status: 'checking' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'red'"
        :data="String(claimCounts.reject || 0)"
        :subtitle="'Data'"
        :status="'Ditolak'"
        :route-name="'Claim'"
        :query-params="{ status: 'reject' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'orange'"
        :data="String(claimCounts.administration || 0)"
        :subtitle="'Data'"
        :status="'Proses Administrasi'"
        :route-name="'Claim'"
        :query-params="{ status: 'administration' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'grey'"
        :data="String(claimCounts.recheck || 0)"
        :subtitle="'Data'"
        :status="'Pemeriksaan Ulang'"
        :route-name="'Claim'"
        :query-params="{ status: 'recheck' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'grey'"
        :data="String(claimCounts.transfered || 0)"
        :subtitle="'Data'"
        :status="'Tabungan Telah Dikirim'"
        :route-name="'Claim'"
        :query-params="{ status: 'transfered' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-4@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'black'"
        :type-status="'green'"
        :data="String(claimCounts.approve || 0)"
        :subtitle="'Data'"
        :status="'Disetujui'"
        :route-name="'Claim'"
        :query-params="{ status: 'approve' }"
      />
    </div>
  </div>
</template>

<script>
import CardStatus from '@/components/globals/card/CardStatus'

export default {
  components: {
    CardStatus
  },
  props: {
    isLoading: {
      required: false,
      type: Boolean
    },
    isCompanyRole: {
      required: false,
      type: Boolean,
      default: false
    },
    claimCounts: {
      required: false,
      type: Object,
      default: () => ({})
    }
  }
}
</script>
